import ForgotPassword from "../Auth/ForgotPassword";

function ForgotPage() {
    return (
        <>
        <div>
            <ForgotPassword/>
        </div>
        </>
    );
}

export default ForgotPage;